/**
 * @param str String to convert to sentence case
 * @description Converts the first character of a string to uppercase and the rest to lowercase.
 *              This is useful for formatting strings that are not already in sentence case.
 *              For example, "hello world" would become "Hello world".
 *              Note: This function does not handle special cases like "iPhone" or "eBay".
 *              It simply capitalizes the first character and leaves the rest as is.
 * @returns
 */
const toSentenceCase = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1)

export { toSentenceCase }
